<template>
  <optgroup label="Sondervorstellungen" v-if="specialPerformance">
    <option
      :disabled="performance.remainingTickets! <= 0"
      :value="performance"
      v-for="performance in performances.filter(
        (performance) => performance.specialPerformance == true
      )"
    >
      {{ formatPerformanceOption(performance) }}
    </option>
  </optgroup>
  <optgroup label="Standardvorstellungen" v-else>
    <option
      :disabled="performance.remainingTickets! <= 0"
      :value="performance"
      v-for="performance in performances.filter(
        (performance) => performance.specialPerformance == false
      )"
    >
      {{ formatPerformanceOption(performance) }}
    </option>
  </optgroup>
</template>

<script lang="tsx" setup>
defineProps<{
  specialPerformance: boolean;
  performances: CircusPerformance[];
}>();

const formatPerformanceOption = (performance: CircusPerformance) => {
  const date = new Date(performance.date).toLocaleDateString("de");
  const time = new Date(performance.date).toLocaleTimeString("de");
  const name = performance.name.length > 0 ? `- ${performance.name}` : "";
  const seats =
    performance.remainingTickets! > 0
      ? `${performance.remainingTickets} Plätze verfügbar`
      : "";
  const soldOut =
    performance.remainingTickets! <= 0
      ? "(Karten nur noch an der Tageskasse erhältlich)"
      : "";

  if (performance.noPresale) {
    return `${date} - ${time} ${name} - Eintritt frei - keine Reservierung nötig`.trim();
  }

  return `${date} - ${time} ${performance.specialPerformance ? name : ""} - ${seats} ${soldOut}`.trim();
};
</script>
